export const DownloadIcon = () => {
  return (
    <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.46736 12.9992C7.79892 12.9992 5.93935 12.9977 4.14162 12.9977C2.66588 12.9977 1.46929 11.8003 1.4707 10.3245C1.47291 8.02289 1.47291 5.97553 1.4707 3.67392C1.46929 2.19817 2.66594 1.00095 4.14169 1.00195C5.91433 1.00316 7.68698 1.00316 9.45962 1.00195C10.9354 1.00095 12.132 2.19797 12.1317 3.67372C12.1312 5.87406 12.1339 7.83198 12.1339 10.3325M9.46736 12.9992V10.9992C9.46736 10.631 9.76584 10.3325 10.134 10.3325H12.1339M9.46736 12.9992L12.1339 10.3325M5.80069 4.77688L5.80069 8.33244M5.80069 8.33244L3.46736 6.44811M5.80069 8.33244L8.13403 6.44811M5.80069 2.99921V3.5918"
        stroke="#0D6EFD"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
